// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { memo } from 'react'
import classNames from 'classnames'
import Switch from 'react-switch'
import { OFF_TEXT, ON_TEXT } from '../../../../../utils/constants'
import './PreferencesToggle.scss'

// @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
export const PreferencesToggle = memo(({ isActive, setIsActive, description, isTheLast }) => (
  <div
    className={classNames('preferences-toggle-main-wrapper', {
      'preferences-toggle-main-wrapper--margin': !isTheLast,
    })}>
    <Switch
      onChange={setIsActive}
      checked={isActive}
      offColor='#B0BDCB'
      onColor='#00A2B2'
      height={30}
      width={66}
      uncheckedIcon={<div className='availability-popUp-recurrence-switcher-off-container'>{OFF_TEXT}</div>}
      checkedIcon={<div className='availability-popUp-recurrence-switcher-on-container'>{ON_TEXT}</div>}
      activeBoxShadow='#ffffff'
    />
    <div className='preferences-toggle-description'>{description}</div>
  </div>
))
